<template>
  <div>
  <strong>{{ tip_header }}:</strong><br>
  <p v-html="tip"></p>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { defineProps } from 'vue';

const props = defineProps({
  totalCapacity: { type: Number, required: true },
  producedEnergy: { type: Number, required: true },
  storedEnergy: { type: Number, required: true },
  soldPercentage: { type: Number, required: true },
  wastedPercentage: { type: Number, required: true }
});

const tips = computed(() => {
  const { totalCapacity, producedEnergy, storedEnergy, soldPercentage, wastedPercentage } = props;

  const storedRatio = storedEnergy / totalCapacity;
  const soldRatio = soldPercentage / 100;
  const wastedRatio = wastedPercentage / 100;

  if (wastedRatio > 0.2) {
    return {
      tip_header: "High Waste Detected",
      tip: `High energy waste detected (${(wastedRatio * 100).toFixed(1)}%). Consider changing the strategy to sell the energy faster.`
    };
  } 
  else if (storedRatio > 0.8) {
    return {
      tip_header: "Storage Nearly Full",
      tip: `Your storage is nearly full (${storedEnergy} kWh). Consider selling excess energy to maximize profits.`
    };
  } else if (soldRatio < 0.3) {
    return {
      tip_header: "Lower Your Price",
      tip: `You are selling only ${soldPercentage.toFixed(1)}% of your capacity (${totalCapacity}). Consider lowering your price to be more competitive.`
    };
  } else {
    return {
      tip_header: "Energy Balanced",
      tip: `Everything looks good. You are using your current capacity effectively.`
    };
  }
});

const tip_header = computed(() => tips.value.tip_header);
const tip = computed(() => tips.value.tip);
</script>
